/* eslint-disable indent */
    const trackingUtils = require('../../modules/utils/tracking.utils');
    const filterModelMixin = require('./utils/filter.model.mixin');
    const templateSelectorsViewMixin = require('./utils/template_selector.view.mixin');
    const checkBoxFilterMixin = require('./utils/checkbox_filter.mixin');
    const checkBoxFilterViewMixin = require('./utils/checkbox_filter.view.mixin');
    const CheckboxCollection = require('./utils/checkbox.collection');
    const AirlineModel = Backbone.Model.extend();
    const AirlineCollection = CheckboxCollection.extend({
        model: AirlineModel,
    });
    const filterMixin = require('./utils/filter.mixin.js');
    const filterViewMixin = require('./utils/filter.view.mixin');
    const filterModelProps = require('./utils/model_props');

    const changeIncludeInputsState = function(view, data, cb) {
        cb = Odigeo._.isFunction(cb) ? cb : Odigeo._.identity;
        view.changeQueryState(toArrayParams({
            includeTrains: {disabled: cb(data.hasTrains)},
            airlinesAll: {disabled: cb(data.visibleAirlinesAll)},
            trainsAll: {disabled: cb(data.visibleLowCostsTrainsAll)},
        }));
    };
    const toArrayParams = require('./utils/to_array_params');

    Odigeo.defineWidget('airlines_filter', Odigeo.Widget.extend(Odigeo._.defaults({
        modelClass: Odigeo.Model.extend(Odigeo._.defaults({
            defaults() {
                return {
                    airlines: new AirlineCollection(),
                };
            },
            modelProps: filterModelProps.airlines,
            getRequestModel() {
                return {
                    selectedItems: this.get('airlines')
                        .filter(function(airline) {
                            return airline.get('active');
                        })
                        .map(function(airline) {
                            return airline.get('code');
                        }),
                };
            },
            isZeroApplied() {
                return this.get('airlines').numSelected === 0;
            },
            isFilterApplied() {
                const airlineCollection = this.get('airlines');
                return airlineCollection.length !== airlineCollection.numSelected;
            },
            getTagInfo() {
                const airlinesCollection = this.get('airlines');
                const airline = airlinesCollection.find(Odigeo._.method('get', 'active'));
                return {
                    airlineName: Odigeo._.method('get', 'name')(airline),
                    numSelected: airlinesCollection.numSelected,
                };
            },
        }, filterModelMixin)),
        viewClass: Odigeo.View.extend(Odigeo._.defaults({
            events: {
                'change .filter_checkbox': 'onFilter',
                'tap .button_all': 'onButtonAllClick',
                'tap .button_none': 'onButtonNoneClick',
            },
            renderSelectedAirlines(airlines) {
                airlines.each(Odigeo._.bind(function(airline, index) {
                    $(this.$cachedSelectors.filterInput[index]).prop('checked', airline.get('active'));
                }, this));
            },
            updateFilter(idx, fMetadata) {
                changeIncludeInputsState(this, fMetadata, function(e) {
                    return !e;
                });

                this.setIsFiltered(idx, fMetadata);
            },

            setIsFiltered(idx, fMetadata) {
                const airlinesCount = this.$el.find('.filter_checkbox:checked').length;
                const airlinesDefautlCount = fMetadata.airlinesCollection.length;

                Odigeo.trigger(this.widget.widgetType + ':filtersUpdated', idx, 'airlines_filter', airlinesCount !== airlinesDefautlCount);
            },

            initFilter(data) {
                this.changeQueryState(toArrayParams({
                    airlinesNone: {disabled: false},
                }));

                changeIncludeInputsState(this, this.model.toJSON());
                this.model.get('airlines').reset(data.airlinesCollection);
                this.enableAirlineInputs();
            },

            resetFilter() {
                const airlineCollection = this.model.get('airlines');
                airlineCollection.turnOnAll();
                this.renderSelectedAirlines(airlineCollection);
                this.changeQueryState(toArrayParams({
                    airlinesNone: {disabled: false},
                }));
                Odigeo.trigger(this.widget.widgetType + ':enableAirlineInputs');
                Odigeo.trigger(this.widget.widgetType + ':resetFreeRebooking');
            },
            enableAirlineInputs() {
                this.$el.find('.free_rebooking_filter_applied').toggleClass('odf-hidden', true);
                const airlineCollectionInputs = this.el.querySelectorAll('.filter_checkbox');
                this.removeDisableInputs(airlineCollectionInputs);
            },
            removeDisableInputs(inputs) {
                inputs.forEach((e) => e.hasAttribute('disabled') && e.removeAttribute('disabled') );
            },

            updateIfFreeRebookingFilter(isChecked, airlinesList) {
                if (isChecked && !!airlinesList) {
                    this.$el.find('.free_rebooking_filter_applied').toggleClass('odf-hidden', false);
                    const airlineCollection = this.model.get('airlines');
                    airlineCollection.turnOnByIdList(airlinesList.split('#'));
                    this.renderSelectedAirlines(airlineCollection);
                    this.changeQueryState(toArrayParams({
                        airlinesNone: {disabled: false},
                    }));
                    this.el.querySelectorAll('.filter_checkbox').forEach((e) => {
                        !e.checked && e.setAttribute('disabled', true);
                    });
                } else {
                    this.resetFilter();
                }
            },

            onClickAllLowCosts() {
                const widgetType = this.widget.widgetType;
                this.changeQueryState(toArrayParams({
                    includeTrains: {checked: true},
                }));
                trackingUtils.trackEvent('results_filters', 'include_select_all', 'flights_results');
                Odigeo.trigger(widgetType + ':filtersLoading');
                Odigeo.trigger(widgetType + ':filter-request', ['trains']);
            },

            onButtonAllClick() {
                if (Odigeo.SessionScope.flow === 'mobile' && Odigeo.AB.isFilterLayerEnabled) {
                    trackingUtils.trackEvent('results_filters', 'airlines_select_reset', 'flights_results');
                } else {
                    trackingUtils.trackEvent('results_filters', 'airlines_select_all', 'flights_results');
                }
                this.resetFilter();
            },

            onButtonNoneClick() {
                const airlineCollection = this.model.get('airlines');
                trackingUtils.trackEvent('results_filters', 'airlines_select_none', 'flights_results');
                airlineCollection.turnOffAll();
                this.renderSelectedAirlines(airlineCollection);
                this.changeQueryState(toArrayParams({
                    airlinesAll: {disabled: false},
                    airlinesNone: {disabled: true},
                }));
                if (this.widget.options.updateOnNoneSelected) {
                    Odigeo.trigger('filters-manager:zeroFilteredResults');
                }
            },

            onOnlyClickFilter(params) {
                const id = params.id;
                const carrierId = id.replace('airlines', '');
                const airlineCollection = this.model.get('airlines');
                airlineCollection.turnOnById(carrierId);
                this.renderSelectedAirlines(airlineCollection);
                this.changeQueryState(toArrayParams({
                    airlinesAll: {disabled: false},
                    airlinesNone: {disabled: true},
                }));
            },

            onTrainsFilter() {
                const widgetType = this.widget.widgetType;
                Odigeo.trigger(widgetType + ':filtersLoading');
                Odigeo.trigger(widgetType + ':filter-request', ['trains']);
                const checkedString = this.$cachedSelectors.includeTrains.is(':checked') ? 'checked' : 'unchecked';
                trackingUtils.trackEvent('results_filters', 'include_trains_' + checkedString, 'flights_results');
            },

            onFilter(event) {
                const params = this.getParams(event);
                const carrierId = params.id;
                this.model.get('airlines').toggle(carrierId);
            },

            templateSelectors: {
                label: '.carrier_name',
                filterInput: '[name=airlines${idx}]',
                filterAll: '#airlinesAll${idx}',
                includeTrains: '#includeTrains${idx}',
                airlinesAll: '#airlinesAll${idx}',
                trainsAll: '#trainsAll${idx}',
                airlinesNone: '#airlinesNone${idx}',
            },
        }, checkBoxFilterViewMixin, templateSelectorsViewMixin, filterViewMixin)),

        onToggle(models) {
            const model = Odigeo._.isArray(models) ? models[0] : models;
            const checkedString = model.get('active') ? 'checked' : 'unchecked';
            const carrier = model.get('name').replace(/\s+/, '_').toLowerCase();
            const filterInputArray = this.view.$cachedSelectors.filterInput.toArray();
            trackingUtils.trackEvent('results_filters', 'airlines_' + checkedString + '_' + carrier, 'flights_results');

            this.view.changeQueryState(toArrayParams({
                airlinesNone: {disabled: this.isAllAirlinesUnchecked(filterInputArray)},
            }));

            this.filterRequestAirlines();
        },

        isAllAirlinesUnchecked(InputsArray) {
            return InputsArray.every((e) => !e.checked);
        },

        updateIfFreeRebookingFilter(isChecked, airlinesList) {
            this.view.updateIfFreeRebookingFilter(isChecked, airlinesList);
        },

        enableAirlineInputs() {
            this.view.enableAirlineInputs();
        },

        checkNullFilter(idx, airlinesList, cb) {
            this.rebuildWidgetIfNeeded(idx);
            this.view.checkNullFilter(idx, airlinesList, cb);
        },

        onTrainsFilter(idx) {
            this.rebuildWidgetIfNeeded(idx);
            this.view.onTrainsFilter();
        },

        filterRequestAirlines() {
            Odigeo.trigger(this.widgetType + ':filtersLoading');
            this.model.filterRequest(['airlines']);
        },

        sendIsZeroApplied(requestType) {
            Odigeo.trigger(this.widgetType + ':sendIsZeroApplied', this.model.isZeroApplied(), requestType, this.model.get('idx'));
        },

        bindEvents() {
            const airlineCollection = this.model.get('airlines');
            this.listenTo(airlineCollection, 'reset', Odigeo._.bind(this.view.renderSelectedAirlines, this.view));
            this.listenTo(airlineCollection, 'turn-on', Odigeo._.bind(this.onToggle, this));
            this.listenTo(airlineCollection, 'turn-on-all', Odigeo._.bind(this.filterRequestAirlines, this));
            this.listenTo(airlineCollection, 'turn-off-all', Odigeo._.bind(this.filterRequestAirlines, this));
            this.listenTo(airlineCollection, 'updateBySelected', Odigeo._.bind(this.filterRequestAirlines, this));
            this.listenTo(airlineCollection, 'toggle', Odigeo._.bind(this.onToggle, this));
            this.listenTo(airlineCollection, 'update', this.triggerFilterChange);
            this.listenTo(airlineCollection, 'reset', this.triggerFilterChange);
        },

        filterType: 'airlines',
    }, filterMixin, checkBoxFilterMixin)));
